import React from "react";
import { Link } from "react-router-dom";
import Image from "../../ui/image";
import { Images } from "../../../lib/images";

function footer() {
  return (
    <div className="bg-white py-8 px-5">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-4 items-center justify-between w-full pb-10 font-inter text-black font-normal text-base">
          <Link to="/">
            <Image alt="Logo" src={Images.Footerlogo} className="h-10 lg:me-5" />
          </Link>
          <div className="w-auto flex flex-col sm:flex-row gap-5 md:gap-10 text-center py-2 lg:py-0">
            <Link to="/" className="hover:underline">
              Home
            </Link>
            <Link to="/league-table" className="hover:underline">
              League Table
            </Link>
            <Link to="/club-profile" className="hover:underline">
              Club Profiles
            </Link>
            <Link to="/analytics" className="hover:underline">
              Analytics
            </Link>
          </div>
          <div className="flex gap-2">
            <Link to="/" className="transition-transform duration-300 ease-in-out transform hover:scale-110 hover:shadow-xl rounded-full">
              <Image alt="facebook" src={Images.Facebook} className="" />
            </Link>
            <Link to="/" className="transition-transform duration-300 ease-in-out transform hover:scale-110 hover:shadow-xl rounded-full">
              <Image alt="twitter" src={Images.Twitter} className="" />
            </Link>
            <Link to="/" className="transition-transform duration-300 ease-in-out transform hover:scale-110 hover:shadow-xl rounded-full">
              <Image alt="instagram" src={Images.Instagram} className="" />
            </Link>
            <Link to="/" className="transition-transform duration-300 ease-in-out transform hover:scale-110 hover:shadow-xl rounded-full">
              <Image alt="youtube" src={Images.Youtube} className="" />
            </Link>
          </div>
        </div>
        <div className="footerBtm">
          <span className="text-greyColor bg-white relative top-3 px-5 inline-block w-80% sm:w-auto">
            Copyright &copy; {new Date().getFullYear()} MYBIGCLUB. All rights reserved.
          </span>
        </div>
      </div>
    </div>
  );
}

export default footer;
